import { ScheduleQueryParams } from '@nextforce/api'

const keys = {
  all: ['schedule'],
  list: (params: ScheduleQueryParams) => [...keys.all, params],
}

export default keys
